import { PlayerService } from "./PlayerService";

type CheckCodeResponse = {
    correct: boolean;
    chestSecret: string;
};

export class MiniGameService {
    private _playerService: PlayerService = new PlayerService();
    public async checkCode(code: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}miniGame/check-code/${code}`, {
            method: "GET",
            headers: {
                "X-playerSessionId": this._playerService.getPlayerSessionId(),
            },
        });
        const data: CheckCodeResponse = await response.json() as CheckCodeResponse;
        localStorage.setItem("codeToChest", data.chestSecret);
        return data.correct;
    }
};
